import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getClinicSkinServiceMasterByClinicId } from "../../../../store/slices/clinicSkinServiceMaster";
import Select from "react-select";

const Skin = ({ handleChange, isClient }) => {
  const [selectedSkinServices, setSelectedSkinServices] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const dispatch = useDispatch();
  const { clinicSkinServiceMasterByClinicId } = useSelector(
    (state) => state.clinicSkinServiceMaster
  );
  const { token } = useSelector((state) => state.auth);
const clinicId =clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getClinicSkinServiceMasterByClinicId({
        clinicId,
        token,
      })
    );
  }, [dispatch, clinicId, token]);

  const handleSelectedSkinService = (selectedOptions) => {
    setSelectedSkinServices(selectedOptions || []);
    handleChange(
      (selectedOptions || []).map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  };
  useEffect(() => {
    if (!selectedSkinServices.length) return;

    const updatedServices = selectedSkinServices.map((option) => {
      const servicePrice =
        clinicSkinServiceMasterByClinicId?.[0]?.services?.find(
          (serv) => serv._id === option.value
        );

      return {
        ...option,
        price:
          isClient === "Yes"
            ? servicePrice?.client_price
            : servicePrice?.pt_price,
      };
    });

    setSelectedSkinServices(updatedServices);

    handleChange(
      updatedServices.map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  }, [isClient]);

  useEffect(() => {
    const totalAmount = selectedSkinServices?.reduce((sum, option) => {
      return sum + (option.price || 0);
    }, 0);

    setTotalAmount(totalAmount);
  }, [selectedSkinServices]);

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={clinicSkinServiceMasterByClinicId?.[0]?.services
              ?.filter((servicedetails) => servicedetails.status === "Active")
              ?.map((servicedetails) => ({
                value: servicedetails?._id,
                label: servicedetails?.serviceDetailName,
                type: "skin",
                price:
                  isClient === "Yes"
                    ? servicedetails?.client_price
                    : servicedetails?.pt_price,
              }))}
            value={selectedSkinServices}
            onChange={handleSelectedSkinService}
            isMulti
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="total-amount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="total-amount"
            value={totalAmount}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default Skin;
